import React from "react";
import ScanHand from "../../ScanHand";

const Screen42 = () => {
  return <ScanHand />;
};

export default Screen42;
